export default __webpack_public_path__ + "static/media/image1.a9b9ee4b.jpg";